var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ye",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v504.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f10600",
    d: "M0 0h512v167.9H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 344.1h512V512H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYe);
export default __webpack_public_path__ + "static/media/ye.9b186a8be867d7cb136d2dcdb89d8d2b.svg";
export { ForwardRef as ReactComponent };